import { OrderDetailEntity, RuleEntity, ChuteEntity } from 'orders/domain/entities/order.entity'
import { OrderDetails, Rule, Chute, OrderDetailsResponse } from 'interfaces/order'

// API response → Domain entity
export function mapApiResponseToOrderDetail(data: OrderDetailsResponse): OrderDetailEntity {
    // Ordenamos los grupos por el chute mínimo ascendente y los chutes internos
    // también ascendente, para que los consumidores obtengan las reglas listas
    // para renderizar.
    const sortedEntries = Object.entries(data.groups)
        .map(([key, rule]) => {
            const sortedChutes = [...(rule.chutes ?? [])].sort(
                (a: Chute, b: Chute) => a.chute_number - b.chute_number,
            )
            return [key, { ...rule, chutes: sortedChutes }] as const
        })
        .sort(([, a], [, b]) => {
            const minA = a.chutes.length > 0 ? a.chutes[0].chute_number : Number.POSITIVE_INFINITY
            const minB = b.chutes.length > 0 ? b.chutes[0].chute_number : Number.POSITIVE_INFINITY
            return minA - minB
        })

    const groups: Record<string, RuleEntity> = {}
    for (const [key, rule] of sortedEntries) {
        groups[key] = {
            totalPackages: rule.total_packages,
            lastUpdate: rule.last_update,
            chutes: rule.chutes.map((c: Chute): ChuteEntity => ({
                chuteNumber: c.chute_number,
                totalPackages: c.total_packages,
                containerCode: c.container_code ?? null,
                chuteState: c.chute_state ?? null,
            })),
        }
    }
    return {
        id: data.id,
        description: data.description,
        state: data.state,
        createdAt: data.created_at,
        total: data.total,
        totalProcessed: data.total_processed,
        totalWithoutProcessed: data.total_without_processed,
        groups,
        operationMode: data.classificationType
            ? { id: data.classificationType.id, code: data.classificationType.key, name: data.classificationType.description }
            : undefined,
        templateName: data.template?.name,
        templateId: data.template?.id,
        lastUpdate: data.last_update ?? null,
    }
}

// Domain entity → View DTO
function toRule(entity: RuleEntity): Rule {
    return {
        total: String(entity.totalPackages),
        totalPackages: entity.totalPackages,
        total_packages: entity.totalPackages,
        last_update: entity.lastUpdate,
        chutes: entity.chutes.map((c: ChuteEntity) => ({
            chute_number: c.chuteNumber,
            total_packages: c.totalPackages,
            container_code: c.containerCode,
            chute_state: c.chuteState,
        })),
    }
}

export function toOrderDetails(entity: OrderDetailEntity): OrderDetails {
    const groups: Record<string, Rule> = {}
    for (const [key, rule] of Object.entries(entity.groups)) {
        groups[key] = toRule(rule)
    }
    return {
        id: entity.id,
        description: entity.description,
        state: entity.state,
        createdAt: entity.createdAt,
        total: entity.total,
        totalProcessed: entity.totalProcessed,
        totalWithoutProcessed: entity.totalWithoutProcessed,
        groups,
        operationMode: entity.operationMode,
        templateName: entity.templateName,
        templateId: entity.templateId,
        lastUpdate: entity.lastUpdate ?? null,
    }
}
